import { useEffect, useState } from 'preact/hooks';
import { Landing } from './pages/Landing';
import { LiveSession } from './pages/LiveSession';
import { CodeEntry } from './pages/CodeEntry';

interface Route {
  shortCode: string | null;
  lang: string | null;
}

function parseRoute(): Route {
  // Path = /<short_code>, query ?lang=<lang>
  const path = window.location.pathname.replace(/^\/+|\/+$/g, '');
  const params = new URLSearchParams(window.location.search);
  return {
    shortCode: path && /^[A-Za-z0-9]{6,12}$/.test(path) ? path.toUpperCase() : null,
    lang: params.get('lang'),
  };
}

export function App() {
  const [route, setRoute] = useState<Route>(parseRoute());

  useEffect(() => {
    const onPop = () => setRoute(parseRoute());
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  function navigate(shortCode: string, lang?: string) {
    const url = lang
      ? `/${shortCode}?lang=${encodeURIComponent(lang)}`
      : `/${shortCode}`;
    window.history.pushState({}, '', url);
    setRoute(parseRoute());
  }

  function clearLang() {
    if (route.shortCode) navigate(route.shortCode);
  }

  if (!route.shortCode) {
    return <CodeEntry onSubmit={(code) => navigate(code)} />;
  }
  if (route.shortCode && route.lang) {
    return (
      <LiveSession shortCode={route.shortCode} lang={route.lang} onLeave={clearLang} />
    );
  }
  return (
    <Landing
      shortCode={route.shortCode}
      onPickLanguage={(lang) => navigate(route.shortCode!, lang)}
    />
  );
}
